import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useLang } from '../../i18n/LanguageContext'
import LanguagePicker from '../../i18n/LanguagePicker'
import './Header.css'

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const { t } = useLang()

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="header-logo">
            <div className="header-logo-icon">
              <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="8" fill="url(#gradient)"/>
                <path d="M12 28V12h4v12h10v4H12z" fill="white"/>
                <defs>
                  <linearGradient id="gradient" x1="0" y1="0" x2="40" y2="40">
                    <stop stopColor="#1e40af"/>
                    <stop offset="1" stopColor="#06b6d4"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <span>CommunityNord</span>
          </Link>

          <nav className="header-nav-desktop">
            <ul className="header-nav-list">
              <li><NavLink to="/features" className="header-nav-link">{t('header.features')}</NavLink></li>
              <li><NavLink to="/pricing" className="header-nav-link">{t('header.pricing')}</NavLink></li>
              <li><NavLink to="/contact" className="header-nav-link">{t('header.contact')}</NavLink></li>
            </ul>
          </nav>

          <div className="header-actions">
            <span className="header-action-desktop"><LanguagePicker /></span>
            <NavLink to="/login" className="header-nav-link header-action-desktop">{t('header.login')}</NavLink>
            <a href="/signup" className="btn btn-outline header-action-desktop">
              {t('header.getStarted')}
            </a>
            <button
              className="header-menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                {mobileMenuOpen ? (
                  <path d="M6 6l12 12M6 18L18 6" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <nav className="header-nav-mobile">
            <ul className="header-mobile-list">
              <li><NavLink to="/features" onClick={() => setMobileMenuOpen(false)}>{t('header.features')}</NavLink></li>
              <li><NavLink to="/pricing" onClick={() => setMobileMenuOpen(false)}>{t('header.pricing')}</NavLink></li>
              <li><NavLink to="/contact" onClick={() => setMobileMenuOpen(false)}>{t('header.contact')}</NavLink></li>
            </ul>
            <div className="header-mobile-actions">
              <LanguagePicker className="lang-picker--mobile" />
              <NavLink to="/login" className="btn btn-primary" onClick={() => setMobileMenuOpen(false)}>{t('header.login')}</NavLink>
              <a href="/signup" className="btn btn-outline">{t('header.getStarted')}</a>
            </div>
          </nav>
        )}
      </div>
    </header>
  )
}

export default Header
